import { render, staticRenderFns } from "./AuthorizedShop.vue?vue&type=template&id=5d5c33fd&scoped=true"
import script from "./AuthorizedShop.vue?vue&type=script&lang=js"
export * from "./AuthorizedShop.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedShop.vue?vue&type=style&index=0&id=5d5c33fd&prod&scoped=true&lang=css"
import style1 from "./AuthorizedShop.vue?vue&type=style&index=1&id=5d5c33fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c33fd",
  null
  
)

export default component.exports